// extracted by mini-css-extract-plugin
module.exports = {"section":"CreateCompany_section__2BSzf","title-card":"CreateCompany_title-card__1oocf","line":"CreateCompany_line__3GmPR","step-card":"CreateCompany_step-card__34luk"};